import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-microstrategy-cdn',
	template: '',
})
export class MicrostrategyCdnComponent implements OnInit {
	microStrategyUrl: string = environment.microStrategyUrl;
	constructor(private renderer: Renderer2) {}

	ngOnInit(): void {
		this.loadExternalScriptsAndStyles();
	}
	loadExternalScriptsAndStyles(): void {
		// Load JavaScript files
		this.loadScript(`${this.microStrategyUrl}/javascript/embeddinglib.js`);
		// Load CSS stylesheets
		this.loadStylesheet(
			`${this.microStrategyUrl}/javascript/bundles/mojo-dossier.js?v=1663039068749`,
		);
		this.loadStylesheet(`${this.microStrategyUrl}/javascript/bundles/vi-gm.js?v=-652135938`);
		this.loadStylesheet(
			`${this.microStrategyUrl}/javascript/bundles/mstr-vi-react-main.js?v=1663039068749`,
		);
	}

	loadScript(scriptUrl: string): void {
		const script = this.renderer.createElement('script');
		script.src = scriptUrl;
		this.renderer.appendChild(document.head, script);
	}

	loadStylesheet(stylesheetUrl: string): void {
		const link = this.renderer.createElement('link');
		link.rel = 'prefetch';
		link.href = stylesheetUrl;
		this.renderer.appendChild(document.head, link);
	}
}
